import { Injectable } from '@angular/core';
import { GenericResponse } from './../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../utils/urls';
import { ServiceFilterModel } from '../business-entities/service-filter-model';

@Injectable({ providedIn: 'root' })
export class SelectServiceData {
    constructor(private dataService: DataService) {}

    GetSelectServiceSectionDetails(serviceFilterModel:ServiceFilterModel): Promise<GenericResponse<any>> {
        return this.dataService.Post<GenericResponse<any>>(Urls.GetSelectServiceSectionDetails,serviceFilterModel).toPromise();
    }

    
    async getWarningLightDropDown(language: string): Promise<GenericResponse<any>> {
        return this.dataService.Get<GenericResponse<any>>(Urls.GetWarningLightDropdown,language).toPromise();
    }
}